<template>
     <v-data-table
    :headers="headers"
    class="elevation-1"
    :pagination.sync="pagination"
    :items="billingHistory"
    item-key="name"
    align-center
  >
    <template v-slot:items="props">
      <td class="text-xs-center" v-if="props.item.isActive"><v-icon @click="remove(props.item)">cancel</v-icon></td>
      <td v-else></td>
      <td class="text-xs-center" v-if="props.item.isActive">
        <v-icon color="green">done</v-icon>
      </td>
      <td class="text-xs-center" v-else>
        <v-icon color="red">not_interested</v-icon>
      </td>
      <td class="text-xs-center">{{props.item.billingBatchNumber}}</td>
      <td class="text-xs-center">{{formatDate(props.item.billingEnd)}}</td>
      <td class="text-xs-center">{{props.item.customersBilled}}</td>
      <td class="text-xs-center">{{props.item.newCustomers}}</td>
      <td class="text-xs-center">{{props.item.cancelledCustomers}}</td>
      <td class="text-xs-center">{{props.item.totalOnceOffBilled | currency}}</td>
      <td class="text-xs-center">{{props.item.totalRecurringBilled | currency}}</td>
    </template>
    <!-- Custom Row count and Paging text -->
    <template
      v-slot:pageText="props"
    >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    <!-- No data Dispalay -->
    <template v-slot:no-data>
      <v-alert :value="true" color="error" icon="warning">Sorry, nothing to display here :(</v-alert>
    </template>
    </v-data-table>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
export default {
    props:['billingHistory'],
    data() {
    return {
      headers:[
                {
          text: "Action",
          align: "center"
        },
        {
          text: "Active",
          align: "center",
          value: "isActive"
        },
        {
          text: "Billing Batch Number",
          align: "center",
          value: "batchNumber"
        },
        {
          text: "Billing Date",
          align: "center",
          value: "batchNumber"
        },
        {
          text: "No of Billed Customers",
          align: "center",
          value: "customersBilled"
        },
        {
          text: "No of New Customers",
          align: "center",
          value: "newCustomers"
        },
        {
          text: "No of Cancellations",
          align: "center",
          value: "cancelledCustomers"
        },
        {
          text: "Once Off Fees Billed",
          align: "center",
          value: "location.unitNo"
        },
        {
          text: "Recurring Fees Billed",
          align: "center",
          value: "location.locationNetwork.name"
        }
            ]
    }
},
    methods:{
        formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    remove(item){
      Api()
      .put('/billingHistorySummary/'+item.id,{
        isActive: false
      })
      .then(
        Api()
        .get('/billingHistory/byBillingBatchNumber/'+item.billingBatchNumber)
        .then(response=>{
          for (let i=0;i<response.data.length;i++){
            Api()
            .put('/billinghistory/'+response.data[i].id,{
              isActive: false
            })
          }
        })
      )
    }
    }
    }
</script>
